
(function() {
  var result = { translations: { "zh-hk": { "i18n": { "duration": { "seconds": "{{ seconds }} \u79D2", "minutes": "{{ minutes }} \u5206\u9418", "hours": "{{ hours }} \u5C0F\u6642", "hoursAndMinutes": "{{ hours }} \u5C0F\u6642 {{ minutes }} \u5206\u9418", "days": "{{ days }} \u65E5", "shortForm": { "seconds": "{{ seconds }} \u79D2", "minutes": "{{ minutes }} \u5206", "hours": "{{ hours }} \u5C0F\u6642", "days": "{{ days }} \u65E5", "hoursAndMinutes": "{{ hours }} \u5C0F\u6642 {{ minutes }} \u5206" } }, "dateTime": { "quarterAndYear": "{{yearNumber}} \u5E74\u7B2C {{quarterNumber}} \u5B63 " }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "zh-hk": "static-7.1333"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1333",
    "ar-eg": "static-7.1333",
    "bg": "static-7.1333",
    "bn": "static-7.1333",
    "ca-es": "static-7.1333",
    "cs": "static-7.1333",
    "da": "static-7.1333",
    "de": "static-7.1333",
    "el": "static-7.1333",
    "en-gb": "static-7.1333",
    "en": "static-7.1333",
    "es-mx": "static-7.1333",
    "es": "static-7.1333",
    "et": "static-7.1333",
    "fi": "static-7.1333",
    "fr-ca": "static-7.1333",
    "fr": "static-7.1333",
    "he-il": "static-7.1333",
    "hi": "static-7.1333",
    "hr": "static-7.1333",
    "hu": "static-7.1333",
    "id": "static-7.1333",
    "it": "static-7.1333",
    "ja": "static-7.1333",
    "ko": "static-7.1333",
    "lt": "static-7.1333",
    "ms": "static-7.1333",
    "nl": "static-7.1333",
    "no": "static-7.1333",
    "pl": "static-7.1333",
    "pt-br": "static-7.1333",
    "pt-pt": "static-7.1333",
    "ro": "static-7.1333",
    "ru": "static-7.1333",
    "sk": "static-7.1333",
    "sl": "static-7.1333",
    "sv": "static-7.1333",
    "th": "static-7.1333",
    "tl": "static-7.1333",
    "tr": "static-7.1333",
    "uk": "static-7.1333",
    "vi": "static-7.1333",
    "x-pseudo": "static-7.1333",
    "zh-cn": "static-7.1333",
    "zh-hk": "static-7.1333",
    "zh-tw": "static-7.1333"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:zh-hk', {version: 'static-7.1333'}); }
})();


